export const cutText = (review: string, requiredLength: number) => {
  if (review.length > requiredLength) {
    return review.slice(0, requiredLength) + '...';
  } else return review;
};
